import { RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading, Tag } from "./primitives";
import { SECURITY } from "@/config/site";
import { ShieldCheck, CheckCircle2, Lock, ArrowLeftRight, Flame, Users, KeyRound, Bug } from "lucide-react";

const ICONS = [ShieldCheck, CheckCircle2, Lock, ArrowLeftRight, Flame, Users, KeyRound, Bug];

export default function SecuritySection() {
  return (
    <Section id="security">
      <div className="flex flex-col items-start gap-6">
        <SectionHeading
          eyebrow="Security"
          title="Security by Design"
          lead="Security takes precedence over rapid feature deployment. The measures below define the security posture of the protocol."
        />
        <Tag tone="future" data-testid="audit-status-badge">
          Audit Status: Planned
        </Tag>
      </div>

      <RevealGroup className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SECURITY.map((s, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <RevealItem key={s.title} data-testid={`security-${i}`}>
              <div className="group flex h-full flex-col gap-4 rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-all duration-500 hover:border-white/20">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/5">
                  <Icon className="h-5 w-5 text-indigo-300" />
                </span>
                <h3 className="font-display text-sm font-bold uppercase leading-tight tracking-tight text-white">
                  {s.title}
                </h3>
                <p className="text-sm leading-relaxed text-gray-400">{s.body}</p>
              </div>
            </RevealItem>
          );
        })}
      </RevealGroup>
    </Section>
  );
}
